import { render, staticRenderFns } from "./SearchArticle.vue?vue&type=template&id=4d6686b5&scoped=true"
import script from "./SearchArticle.vue?vue&type=script&lang=js"
export * from "./SearchArticle.vue?vue&type=script&lang=js"
import style0 from "./SearchArticle.vue?vue&type=style&index=0&id=4d6686b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6686b5",
  null
  
)

export default component.exports